<template>
  <d-row class="my-4">
    <d-col cols="12">
      <d-card>
        <d-card-header
          v-d-toggle.hours-settings-collapse
          class="cursor-pointer"
        >
          <i
            class="material-icons mr-1 animate"
            :class="{ 'rotate-90': !collapsed }"
            >chevron_right</i
          >
          Hours
        </d-card-header>
        <d-collapse
          id="hours-settings-collapse"
          @hide="collapsed = true"
          @show="collapsed = false"
        >
          <d-card-body class="card-body-border">
            <form id="update-hours-form" @submit.prevent="updateHours">
              <vue-form-generator
                :schema="schema"
                :model="model"
                :options="formOptions"
              />
              <input
                type="submit"
                form="update-hours-form"
                value="Save"
                class="btn btn-primary"
              />
            </form>
          </d-card-body>
        </d-collapse>
      </d-card>
    </d-col>
  </d-row>
</template>

<script>
import { keepKeys } from "@/helpers";
import moment from "moment";

const DEFAULT_HOURS_MODEL = {
  id: null,
  published: false,
  available_on: moment()
    .format("L")
    .replace("/", "-"),
  name: null,
  slug: null,
  description: null,
  note: null,
  categories: [],
  nutrition: {},
  base_price: 0,
  variants: {},
  customizations: {},
  tags: [],
  tax_rate: 0,
  sku: null
};

const HOURS_SCHEMA = {
  fields: [
    {
      type: "input",
      inputType: "text",
      label: "Sunday Open Time",
      hint: "24 hour time format",
      model: "sunday_start",
      placeholder: "06:00",
      required: true
    },
    {
      type: "input",
      inputType: "text",
      label: "Sunday Close Time",
      hint: "24 hour time format",
      model: "sunday_end",
      placeholder: "18:00",
      required: true
    },
    {
      type: "checkbox",
      label: "Closed Sundays",
      model: "sunday_closed",
      default: false
    },
    {
      type: "input",
      inputType: "text",
      label: "Monday Open Time",
      hint: "24 hour time format",
      model: "monday_start",
      placeholder: "06:00",
      required: true
    },
    {
      type: "input",
      inputType: "text",
      label: "Monday Close Time",
      hint: "24 hour time format",
      model: "monday_end",
      placeholder: "18:00",
      required: true
    },
    {
      type: "checkbox",
      label: "Closed Mondays",
      model: "monday_closed",
      default: false
    },
    {
      type: "input",
      inputType: "text",
      label: "Tuesday Open Time",
      hint: "24 hour time format",
      model: "tuesday_start",
      placeholder: "06:00",
      required: true
    },
    {
      type: "input",
      inputType: "text",
      label: "Tuesday Close Time",
      hint: "24 hour time format",
      model: "tuesday_end",
      placeholder: "18:00",
      required: true
    },
    {
      type: "checkbox",
      label: "Closed Tuesdays",
      model: "tuesday_closed",
      default: false
    },
    {
      type: "input",
      inputType: "text",
      label: "Wednesday Open Time",
      hint: "24 hour time format",
      model: "wednesday_start",
      placeholder: "06:00",
      required: true
    },
    {
      type: "input",
      inputType: "text",
      label: "Wednesday Close Time",
      hint: "24 hour time format",
      model: "wednesday_end",
      placeholder: "18:00",
      required: true
    },
    {
      type: "checkbox",
      label: "Closed Wednesdays",
      model: "wednesday_closed",
      default: false
    },
    {
      type: "input",
      inputType: "text",
      label: "Thursday Open Time",
      hint: "24 hour time format",
      model: "thursday_start",
      placeholder: "06:00",
      required: true
    },
    {
      type: "input",
      inputType: "text",
      label: "Thursday Close Time",
      hint: "24 hour time format",
      model: "thursday_end",
      placeholder: "18:00",
      required: true
    },
    {
      type: "checkbox",
      label: "Closed Thursdays",
      model: "thursday_closed",
      default: false
    },
    {
      type: "input",
      inputType: "text",
      label: "Friday Open Time",
      hint: "24 hour time format",
      model: "friday_start",
      placeholder: "06:00",
      required: true
    },
    {
      type: "input",
      inputType: "text",
      label: "Friday Close Time",
      hint: "24 hour time format",
      model: "friday_end",
      placeholder: "18:00",
      required: true
    },
    {
      type: "checkbox",
      label: "Closed Fridays",
      model: "friday_closed",
      default: false
    },
    {
      type: "input",
      inputType: "text",
      label: "Saturday Open Time",
      hint: "24 hour time format",
      model: "saturday_start",
      placeholder: "06:00",
      required: true
    },
    {
      type: "input",
      inputType: "text",
      label: "Saturday Close Time",
      hint: "24 hour time format",
      model: "saturday_end",
      placeholder: "18:00",
      required: true
    },
    {
      type: "checkbox",
      label: "Closed Saturdays",
      model: "saturday_closed",
      default: false
    }
  ]
};

const HOURS_OPTIONS = {
  validateAfterLoad: false,
  validateAfterChanged: true,
  validateAsync: true
};

export default {
  data() {
    return {
      model: {},
      schema: HOURS_SCHEMA,
      formOptions: HOURS_OPTIONS,
      collapsed: true
    };
  },
  created() {
    this.model = this.$store.state.settings.settings;
  },
  methods: {
    updateHours() {
      const newSettings = keepKeys(this.model, [
        "sunday_start",
        "sunday_end",
        "sunday_closed",
        "monday_start",
        "monday_end",
        "monday_closed",
        "tuesday_start",
        "tuesday_end",
        "tuesday_closed",
        "wednesday_start",
        "wednesday_end",
        "wednesday_closed",
        "thursday_start",
        "thursday_end",
        "thursday_closed",
        "friday_start",
        "friday_end",
        "friday_closed",
        "saturday_start",
        "saturday_end",
        "saturday_closed"
      ]);
      this.$store
        .dispatch("settings/updateSettings", newSettings)
        .then(data => {
          this.$toasted.show(`Settings Updated Successfully!`, {
            position: "bottom-right",
            duration: 2000
          });
          return data;
        });
    }
  }
};
</script>

<style></style>
